import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import RopeTypeReducer, {
  defaultState,
  asyncActions,
} from 'src/ducks/rope-type.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(RopeTypeReducer, defaultState, asyncActions);
};

type IRopeTypeContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const RopeTypeContext = createContext<Partial<IRopeTypeContext>>({
  state: defaultState,
}) as React.Context<IRopeTypeContext>;

const RopeTypeProvider: React.FC = ({ children }) => {
  const reducer = useReducer();

  return (
    <RopeTypeContext.Provider value={{ ...reducer }}>
      {children}
    </RopeTypeContext.Provider>
  );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const useRopeTypeContext = () => useContext(RopeTypeContext);

export type IUseRopeTypeContext = ReturnType<typeof useRopeTypeContext>;

export { RopeTypeContext, RopeTypeProvider };
